import Nav from "./nav"
import Lightbox from "./lightbox"
// import Animation from "./animation"

document.addEventListener("DOMContentLoaded", function () {
    Nav(jQuery)
    Lightbox(jQuery)
    // Animation(jQuery)
})
